import { ProgressSpinner } from 'primereact/progressspinner';

const Spinner = ({ size = '50px' }) => <ProgressSpinner style={{ width: size, height: size }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />

export default { Spinner }